import { IconButton } from '@material-ui/core';
import * as React from 'react';
import TranslateNew from '@translate/TranslateNew';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import ReplayIcon from '@material-ui/icons/Replay';
import { CORAL_500 } from 'src/main.style';

const tn :TranslateNew = TranslateNew.getInstance();

interface IProps {
  session: any;
  selectFamily: (index:number) => void;
  reloadResources: () => void;
  highlight?:boolean;
}


class FamilySwitch extends React.Component<IProps> {

  public render() {
    const resources:any[] = Array.isArray(this.props.session?.data?.resources)
      ? this.props.session.data.resources
      : [];
    const resList:Array<{index:number, familyName:string}> = [];

    let ind = 0;
    for (const res of resources) {
      resList.push({index:ind, familyName:res.familyName});
      ind++;
    }
    return (
      <div style= {{display: 'flex'}}>
        <select
          onChange={this.handleChangeFamily}
          value={this.props.session.selectedFamily}
          style={{padding: '12px', fontSize: '18px', fontFamily: 'Metropolis', 
            border: (('1px solid '+(this.props.highlight?CORAL_500:"#ccc"))),
            borderRadius: '4px', flex: 1}}
        >
          {
            resList.sort((a,b) => 0 - (b.familyName > a.familyName ? 1 : -1)).map((resource, index) => 
              <option key={index} value={resource.index} >{resource.familyName}</option>)
          }
        </select>
        <IconButton onClick= {this.handleReload}>
            <ReplayIcon />
        </IconButton>
      </div>
    );
  }

  private handleChangeFamily = (event:any) => {
    const lan:string = event.target.value;
    this.props.selectFamily(+lan);
  }

  private handleReload = () => {
    this.props.reloadResources();
  }

}


export default FamilySwitch;



// WEBPACK FOOTER //
// ./src/components/common/familySwitch/familyswitch.component.tsx